<template>
    <div class="AccountSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                <Select v-model="companyId" filterable :placeholder="$t('permission_configuration_management.account.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                  <Option value=" " selected>{{$t('permission_configuration_management.account.all')}}</Option>
                  <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                </Select>
              </Col>
            </div>
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="accountSearchKey" :placeholder="$t('permission_configuration_management.account.checkByAccountName')" @on-search="searchAccount()"/>
            </Col>
            <Col span="8">
                <div>
                    <Button type="primary" @click="addOrUpdateHandle" style="float: left;margin-right: 3px;" v-hasPermission="['permissionsConfigurationManagement:accounts:add_account']">{{$t('permission_configuration_management.account.addAccount') }}</Button>
                    <add-or-update-accounts v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-accounts>
                </div>
                <resource-scan></resource-scan>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateAccounts from './AddOrUpdateAccounts'
    import TableAccounts from '../account/TableAccounts'
    import ResourceScan from '../account/ResourceScan'
    var tableAccounts = TableAccounts;
    export default {
        name: 'AccountSearch',
        components: {
            AddOrUpdateAccounts,
            ResourceScan
        },
        data () {
            return {
                addOrUpdateVisible:false,
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                accountSearchKey:'',
                accountSearchName:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
             },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableAccounts.methods.showAll();
            },
            searchAccount: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('accountSearchName', this.accountSearchKey);
                tableAccounts.methods.showAll();
            },
            // 添加
            /**********************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>
<style scoped>
    .AccountSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/AccountSearch.vue